import React from "react";

export const Users = ({feature}) => (
    (feature.isAdministrator() || feature.isBranchManager()) && (
        <div id="usuarios" className="tab-pane fade in" role="tabpanel">
            <hr className="visible-xs"/>
            <div className="pull-left">
                <h3 className="clearmargin hidden-xs">Usuarios</h3>
                <div className="general-title margintop20 hidden-xs">Cliente</div>
                <div className="general-title visible-xs">Cliente</div>
                <div className="black brandonMd marginbottom15">
                    {feature.socialReason}
                </div>
            </div>
            {feature.isAdministrator() && (
                <div className="pull-right-left">
                    <a href="/Frontend/AltaUsuario" className="btn btn-primary btn-sm">
                        Nuevo usuario
                    </a>
                </div>
            )}
            <div className="clearfix"></div>
            <hr className="visible-xs"/>
            <div className="margintop-20"></div>
            <div className="table-responsive">
                <table id="data-table-usuario" className="table table-pedidos table-perfil">
                    <thead>
                    <tr>
                        <th data-column-id="Id" data-visible="false" data-searchable="false">
                            Id
                        </th>
                        <th data-column-id="NOMBRE">NOMBRE</th>
                        <th data-column-id="ROL">ROL</th>
                        <th data-column-id="commands" data-formatter="commands" data-sortable="false">
                            ACCIONES
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {feature.users.map((user, index) => (
                        <tr key={index}>
                            <td>{user.Id}</td>
                            <td>{user.NombreYApellido}</td>
                            <td>
                                {user.EsAdministrador ? 'Administrador'
                                    : user.EsGerenteSucursal ? 'Gerente sucursal'
                                        : 'Usuario'}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
);